const goBackFunction = (navigate: (backUrl: string) => void, backUrl?: string) => {
  if (backUrl && navigate) {
    navigate(backUrl);
  }
};

export default goBackFunction;
